<div
		copoVirtualScroller
		[dataId]="dataId"
		#scroller="copoVirtualScroller"
		(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)"
		class="copo-no-user-select sidenav-content copo-order-tracking-block"
		@routeAnimation
		cdkScrollable>
	<div class="order-tracking-list-title" translate>search.shipments</div>
	<div class="order-tracking-grid copo-container">
		<div *ngFor="let shipment of scroller.list" class="card-block copo-clickable" [routerLink]="['/order-tracking/shipment/card', shipment.supplierShipmentNumber]" mat-ripple>
			<div class="order-tracking-list-card-header">
				<span class="order-tracking-list-card-header-title">{{ shipment.dispatchAdviceNumber }}</span>
				<span class="order-tracking-list-card-header-ton">{{  shipment.qtyShipmentBrut | copoNumber:'weight':'t' }}</span>
			</div>
			<div class="order-tracking-list-card-informations-block">
				<div class="order-tracking-list-card-information-block">
					<span class="order-card-label" translate>shipment.transport-reference</span>
					<span class="order-card-value">{{ shipment.transportReferenceConcat }}</span>
				</div>
				<div class="order-tracking-list-card-information-block">
					<span class="order-card-label" translate>shipment.filter.transport-mode</span>
					<span class="order-card-value">{{ shipment.transportModeDescription }}</span>
				</div>
			</div>
			<div class="order-tracking-list-card-informations-block">
				<div class="order-tracking-list-card-information-block">
					<span class="order-card-label" translate>shipment.filter.ship-to</span>
					<span class="order-card-value">{{ shipment.shipToDescription }}</span>
				</div>
			</div>
		</div>
		<copo-loading-spinner *ngIf="scroller.loading"></copo-loading-spinner>
		<div translate class="empty-page-text" *ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
	</div>
</div>
